import React, {createContext, useReducer} from 'react'
import {LineHaulListReducer} from "../reducers/LineHaulListReducer";

export const  LineHaulListContext = createContext();

const LineHaulListContextProvider = (props) => {
    const state = {
        arrived: [],
        inComing: []
    }
    const [viewModel, dispatch ] = useReducer(LineHaulListReducer, state)
    return (
        <LineHaulListContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </LineHaulListContext.Provider>
    )
}

export default LineHaulListContextProvider


// WEBPACK FOOTER //
// ./src/components/linehaul/context/LineHaulListContext.js